import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentContainer } from '../../../../core/content-container/content-container';

@Component({
  selector: 'app-mentorship-how-it-works',
  imports: [ContentContainer],
  templateUrl: './mentorship-how-it-works.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MentorshipHowItWorks {}
